import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@material/material.module';

import { MojoInputComponent } from './mojo-input.component';

@NgModule({
  declarations: [MojoInputComponent],
  imports: [CommonModule, MaterialModule, ReactiveFormsModule],
  exports: [MojoInputComponent]
})
export class MojoInputModule {}
